/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1fe678c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tips-modal"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "marginB10"
}, "您正在编辑高危参数，如有错误会导致线上登录、支付流程出现问题。", -1));
const _hoisted_3 = {
  key: 0,
  class: "marginB10"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "此次修改参数：", -1));
const _hoisted_5 = {
  class: "edit-text"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "marginB10 tips"
}, " 请谨慎操作并输入“我已知晓风险并确认修改无误”。 ", -1));
const _hoisted_7 = {
  class: "dialog-footer"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'tipsModal',
  emits: ['ok', 'cancel'],
  setup(__props, {
    expose,
    emit
  }) {
    const editParams = ref('');
    const dialogVisible = ref(false);
    const ruleFormRef = ref();
    const form = ref({
      inputValue: ''
    });
    const inputValidator = (rule, value, callback) => {
      if (form.value.inputValue !== '我已知晓风险并确认修改无误') {
        callback(new Error('请按提示输入正确文本'));
      } else {
        callback();
      }
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        console.log('valid', valid);
        if (valid) {
          console.log(123123);
          emit('ok', 'save');
        }
      });
    };
    const showModal = payload => {
      nextTick(() => {
        dialogVisible.value = true;
        if (payload.editParams) {
          editParams.value = payload.editParams;
        }
      });
    };
    const closeModal = () => {
      var _ruleFormRef$value;
      dialogVisible.value = false;
      form.value.inputValue = '';
      (_ruleFormRef$value = ruleFormRef.value) === null || _ruleFormRef$value === void 0 ? void 0 : _ruleFormRef$value.resetFields();
    };
    const handleClose = () => {
      dialogVisible.value = false;
      emit('cancel');
    };
    expose({
      showModal,
      closeModal
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_dialog = __unplugin_components_4;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "重要提示",
        width: 500,
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => handleOk(_unref(ruleFormRef)))
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_2, _unref(editParams) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(editParams)), 1)])) : _createCommentVNode("", true), _hoisted_6]), _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: _unref(form)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "inputValue",
            rules: {
              required: true,
              validator: inputValidator,
              trigger: 'blur'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).inputValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).inputValue = $event),
              maxlength: 20,
              placeholder: "请输入确认文案"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});